import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Headphones, X } from "lucide-react";
import api from "@/lib/api";
import ChatView from "@/components/ChatView";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";

export default function SupportChat() {
    const { user } = useAuth();
    const { t } = useLang();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [convId, setConvId] = useState(null);
    const [busy, setBusy] = useState(false);

    const openSupport = useCallback(async () => {
        if (!user) {
            navigate("/login");
            return;
        }
        setBusy(true);
        try {
            const { data } = await api.post("/chat/support", {});
            setConvId(data.conversation_id);
            setOpen(true);
        } catch {} finally { setBusy(false); }
    }, [user, navigate]);

    if (!user || user.role === "admin") return null;

    return (
        <>
            {!open && (
                <button
                    onClick={openSupport}
                    disabled={busy}
                    className="fixed bottom-6 end-6 z-40 h-14 w-14 rounded-full bg-terracotta hover:bg-terracotta/90 shadow-2xl grid place-items-center text-white transition-transform hover:scale-105"
                    data-testid="support-chat-fab"
                    aria-label={t("supportChat")}
                    title={t("needHelp")}
                >
                    <Headphones className="w-6 h-6" />
                </button>
            )}
            {open && (
                <div className="fixed bottom-6 end-6 z-40 w-[92vw] max-w-sm h-[70vh] bg-white rounded-3xl shadow-2xl border border-border overflow-hidden flex flex-col" data-testid="support-chat-panel">
                    <button
                        onClick={() => setOpen(false)}
                        className="absolute top-3 end-3 z-10 h-8 w-8 rounded-full bg-white/80 hover:bg-white grid place-items-center"
                        data-testid="support-chat-close"
                        aria-label="Close"
                    >
                        <X className="w-4 h-4" />
                    </button>
                    <ChatView convId={convId} embedded />
                </div>
            )}
        </>
    );
}
